import React from "react";
import "./index.scss";
import classNames from "classnames";

interface IProps<T extends Record<string, any>> {
    columns: { title: string, key: keyof T, [key: string]: any }[] | any,
    data?: T[] | any,
    renderHead?: (columns: { title: string, key: keyof T }[]) => React.ReactNode | any,
    renderBody?: (data: T[]) => React.ReactNode | any,
    hasOuterBorder?: boolean
    rules?: "all" | "columns" | "groups" | "none" | "rows"
}

export const BasicTable = <T extends Record<string, any>>({
    columns,
    data,
    renderHead,
    renderBody,
    hasOuterBorder,
    rules
}: IProps<T>) => {
    return (
        <table rules={rules} className={classNames({ 'outer-border': hasOuterBorder })}>
            {renderHead ? renderHead(columns) :
                <thead>
                    <tr>
                        {columns.map((obj: any, index: number) => (
                            <td key={index + obj.title}>{obj.title}</td>
                        ))}
                    </tr>
                </thead>}
            {renderBody ? renderBody(data || []) :
                <tbody>
                    {data?.map((obj: any, index: number) => (
                        <tr key={index}>
                            {Object.keys(obj).map((columnName, innerIndex) => (
                                <td key={innerIndex + columnName}>{obj[columnName]}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            }
        </table>
    )
}